import React, { useState, useEffect } from "react";
import { useTitle } from "react-use";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "./components/DataTable";

import { getAllLogRecord } from "../../../../../actions/logRecord";
import { getAllEmployees } from "../../../../../actions/employee";

import { Box, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "30px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
  },
  headingPage: {
    marginBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(1),
    borderRadius: "20px",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
  },
}));

function Index() {
  const classes = useStyles();
  useTitle("Log การเปลี่ยนแปลงข้อมูล - HR CORE DATA");
  const dispatch = useDispatch();
  const { result: recordStore } = useSelector((state) => state.logRecord);
  const { result: empStore } = useSelector((state) => state.employees);

  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (recordStore !== null && empStore !== null) {
      let recordList = [...recordStore];
      let empList = [...empStore];

      recordList.forEach(function (element) {
        var empData = empList.filter(function (item) {
          return item.empId === element.empId;
        });

        element.imagePath = empData[0].imagePath;
        element.fullName = empData[0].firstName + " " + empData[0].lastName;
        element.jobPosition = empData[0].jobPosition;
      });

      setRecords(recordList);
    }
    setIsLoading(false);
  }, [recordStore, empStore]);

  useEffect(() => {
    dispatch(getAllLogRecord());
    dispatch(getAllEmployees());
  }, []);

  return (
    <div className={classes.root}>
      <Box className={classes.headingPage}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">Log การเปลี่ยนแปลงข้อมูล</Typography>
          </Grid>
        </Grid>
      </Box>
      <Paper className={classes.paper}>
        <DataTable records={records} isLoading={isLoading} />
      </Paper>
    </div>
  );
}

export default Index;
